import { cn } from '@/lib/utils';
import ActionButton from '@/components/buttons/ActionButton.tsx';
import {
  ACCEPTANCE_LINK_NOTE,
  PREVIEW_ONLY_TITLE,
} from './clientAcceptanceCopy.ts';

interface ClientAcceptanceActionsProps
  extends React.HTMLAttributes<HTMLDivElement> {
  /** Czy paczka niesie dokumenty do podpisu — decyduje o treści przycisku. */
  hasDocuments: boolean;
}

/** Stopka strony klienta: decyzja i dopisek o tym, jak długo link działa. */
const ClientAcceptanceActions = ({
  hasDocuments,
  className,
  ...props
}: ClientAcceptanceActionsProps) => (
  <div
    className={cn(
      '@max-[700px]:flex-col @max-[700px]:items-stretch @max-[700px]:px-4 flex flex-wrap items-center gap-3 px-[26px] pb-6 pt-5',
      className,
    )}
    {...props}
  >
    <ActionButton tone="success" size="lg" disabled title={PREVIEW_ONLY_TITLE}>
      {hasDocuments ? 'Akceptuję zmiany i dokumenty' : 'Akceptuję zmiany'}
    </ActionButton>
    <ActionButton tone="outline" size="lg" disabled title={PREVIEW_ONLY_TITLE}>
      Odrzucam zmiany
    </ActionButton>
    <span className="@max-[700px]:ml-0 @max-[700px]:text-center ml-auto text-[13px] text-neutral-400">
      {ACCEPTANCE_LINK_NOTE}
    </span>
  </div>
);

export default ClientAcceptanceActions;
